import { useLookupsStore } from '../useLookupsStore/useLookupsStore'

// Configuration object that maps menu item urlSegments to their visibility conditions.
// Each condition is a function that returns true if the item should be visible.

const visibilityConditions = {
  'bank-feeds': () => {
    return useLookupsStore.getState().enableBankFeeds === true
  },
  'document-bundles': () => {
    return useLookupsStore.getState().enableBundledocs === true
  },
  'expense-claims': () => {
    return useLookupsStore.getState().enableExpenses === true
  },
  'overtime-claims': () => {
    return useLookupsStore.getState().enableOvertime === true
  },
  'employee-claims': () => {
    const state = useLookupsStore.getState()
    return state.enableExpenses === true || state.enableOvertime === true
  }
}

export const filterMenuItemsByVisibility = (menuItems) => {
  if (!Array.isArray(menuItems)) {
    return menuItems
  }

  return menuItems
    .map((item) => {
      // Check if this item has a visibility condition
      const visibilityCondition = visibilityConditions[item.urlSegment]

      if (visibilityCondition) {
        // If condition exists and returns false, filter out this item
        if (!visibilityCondition()) {
          console.log('Condition not met,filtering out', item.urlSegment)
          return null
        }
      }

      // Recursively filter children if they exist
      if (item.children && Array.isArray(item.children)) {
        const filteredChildren = filterMenuItemsByVisibility(item.children)
        return { ...item, children: filteredChildren }
      }

      return item
    })
    .filter(Boolean) // Remove null items
}
